import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import { renderImage, FUTURE_EPG_MODAL_IMAGE } from 'helpers/ImageHelper';
import { SITE_PLATFORM_WEB } from 'helpers/BreakpointHelper';
import { helperGetStaticContentUrl } from 'helpers/RouteHelper';
import CallSign from 'components/CallSign';
import Style from './ModalImage.module.scss';

const foxFallbackImg = helperGetStaticContentUrl('images', 'FallBack-FOX.jpg');

const ModalImage = ({
  showPlayButton,
  callSign,
  breakpoint = SITE_PLATFORM_WEB,
  image,
  onPlayButtonClick,
}) => (
  <div className={Style.imageContainer}>
    <div className={Style.networkLogo}>
      <CallSign callSign={callSign} color="white" />
    </div>
    <div className={Style.overlayContainer}>
      {renderImage({
        alt: 'EPG modal image',
        breakpoint,
        className: Style.image,
        imageType: FUTURE_EPG_MODAL_IMAGE,
        src: image || foxFallbackImg,
      })}
      {showPlayButton && (
        <button className={Style.playIcon} onClick={onPlayButtonClick}>
          <Icon icon="play-button-thin" color="white" size="full" viewBox="1 1 36 36" />
        </button>
      )}
    </div>
  </div>
);

ModalImage.propTypes = {
  breakpoint: PropTypes.string,
  callSign: PropTypes.string,
  image: PropTypes.string,
  onPlayButtonClick: PropTypes.func,
  showPlayButton: PropTypes.bool,
};

export default ModalImage;
